module.exports = __webpack_public_path__ + "static/media/uncheck.9cd222fe.svg";